<template>
  <div class="modal">
    <div class="modal__background"></div>
    <div
      class="modal__content"
      :style="{
        'align-content': calcAlignContent,
        'justify-content': calcJustifyContent,
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
  modalOptions: {
    type: Object,
    required: false,
  },
});

const calcJustifyContent = computed(
  () => props.modalOptions?.alignment?.justifyContent || "center"
);

const calcAlignContent = computed(
  () => props.modalOptions?.alignment?.alignContent || "center"
);
</script>
<style lang="scss">
.modal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;

  &__content {
    width: 100%;
    height: 100%;
    display: grid;
    align-content: center;
  }

  &__background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: var(--modal-background);
    filter: blur(5rem);
    z-index: -1;
  }
}
</style>
